import React from 'react';
import { ArrowRight } from 'lucide-react';

const APP_STORE_URL = 'https://apps.apple.com/app/id6751061434';

const CTA = () => {
  return (
    <section id="cta" className="relative py-32 px-6 lg:px-12" style={{ background: '#08080f' }}>
      <div className="max-w-3xl mx-auto text-center relative z-10">

        {/* Glow accent */}
        <div
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full pointer-events-none"
          style={{ background: 'radial-gradient(circle, rgba(124, 58, 237, 0.08) 0%, rgba(0, 210, 106, 0.04) 60%, transparent 70%)' }}
        ></div>

        <div className="relative">
          <div className="section-label mb-8">Let's go</div>

          <h2 className="text-5xl lg:text-7xl font-black tracking-tight mb-6 leading-[1.05]">
            You've read enough.
            <br />
            <span className="gradient-text">Start the clock.</span>
          </h2>

          <p className="text-lg text-[rgba(255,255,255,0.45)] mb-4 max-w-md mx-auto">
            Pick one thing you've been putting off.
            Open TickBoom. Commit to 25 minutes.
          </p>
          <p className="text-sm text-[#6b7280] mb-12">
            Free to download · Quick sign-up · iOS only
          </p>

          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary text-base"
          >
            Download on App Store
            <ArrowRight size={18} />
          </a>

          {/* Bottom stats */}
          <div className="mt-16 pt-10 border-t border-[rgba(255,255,255,0.06)] grid grid-cols-3 gap-6 max-w-xs mx-auto">
            <div>
              <div className="text-xl font-bold text-white font-mono">Free</div>
              <div className="text-xs text-[#6b7280] uppercase tracking-widest mt-1">To Start</div>
            </div>
            <div>
              <div className="text-xl font-bold text-white font-mono">iOS</div>
              <div className="text-xs text-[#6b7280] uppercase tracking-widest mt-1">Only</div>
            </div>
            <div>
              <div className="text-xl font-bold font-mono">😈</div>
              <div className="text-xs text-[#6b7280] uppercase tracking-widest mt-1">No Excuses</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
